import { initializePostHog } from '@/lib/posthog';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

export function PostHogInitializer({ hasConsent }) {
  const { data: session } = useSession();

  useEffect(() => {
    if (!hasConsent) {
      return;
    }

    const posthog = initializePostHog();
    const user = session?.user;

    if (user?.id) {
      posthog.identify(user.id, {
        email: user.email,
        name: user.name,
      });
    }
  }, [hasConsent, session]);

  return null;
}
